export default __webpack_public_path__ + "static/media/certificate-four.bf286683.png";